import { set, wait } from 'cerebral/operators'
import { props } from 'cerebral/tags'
import snackbarListManipulation from '../factories/snackbarListManipulation'
import updateSnackbar from '../actions/updateSnackbar'
import { snackbar } from 'consts'

export default [
  set(props`snackbar.visible`, false),
  updateSnackbar,
  wait(snackbar.animationTime),
  snackbarListManipulation(
    ({ props }, acc, snackbar) =>
      snackbar.id === props.snackbar.id ? acc : [...acc, snackbar]
  )
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/removeSnackbar.js